module.exports = __webpack_public_path__ + "img/jdw.f4f0dae1.png";